import Swiper from "swiper";
import { FreeMode, Navigation } from "swiper/modules";

export class SubNavSwiper {
  static init(): void {
    document
      .querySelectorAll<HTMLElement>(".no-sub-nav")
      .forEach((navEl) => SubNavSwiper.mount(navEl));
  }

  private static mount(navEl: HTMLElement): void {
    // 이미 초기화된 노드는 재초기화(template:components-init)에서 건너뛴다.
    if (navEl.dataset.subNavSwiperBound === "true") return;

    const list = navEl.querySelector<HTMLElement>(".no-sub-nav__list");
    if (!list) return;

    navEl.dataset.subNavSwiperBound = "true";

    // 슬라이드 클래스 부여
    list.querySelectorAll(".no-sub-nav__item").forEach((item) => {
      item.classList.add("swiper-slide");
    });
    list.classList.add("swiper-wrapper");
    navEl.classList.add("swiper");

    // prev / next 버튼
    const prevBtn = document.createElement("button");
    prevBtn.type = "button";
    prevBtn.className = "no-sub-nav__arrow no-sub-nav__arrow--prev";
    prevBtn.setAttribute("aria-label", "Previous");

    const nextBtn = document.createElement("button");
    nextBtn.type = "button";
    nextBtn.className = "no-sub-nav__arrow no-sub-nav__arrow--next";
    nextBtn.setAttribute("aria-label", "Next");

    navEl.appendChild(prevBtn);
    navEl.appendChild(nextBtn);

    const swiper = new Swiper(navEl, {
      modules: [FreeMode, Navigation],
      slidesPerView: "auto",
      freeMode: { enabled: true, momentum: false },
      watchOverflow: true,
      // 초기 숨김(0-width) 상태로 마운트되어도 노출/리사이즈 시 self-heal.
      observer: true,
      observeParents: true,
      resizeObserver: true,
      navigation: { prevEl: prevBtn, nextEl: nextBtn },
    });

    // 활성 탭 위치로 이동
    const slides = [...list.querySelectorAll(".no-sub-nav__item")];
    const activeIndex = slides.findIndex((item) =>
      item.classList.contains("is-active"),
    );
    if (activeIndex > 0) swiper.slideTo(activeIndex, 0);
  }
}
